import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    menuWrite: () =>
        __('Evaluer arbejdsplads'),
    menuSend: () =>
        __('Uddyb og gem'),

    writeOverall: () =>
        __('Din overordnede evaluering:'),
    writeCategoryHeader: () =>
        __('Hvordan evaluerer du ...'),
    writePositive: () =>
        __('Positivt (maks. 600 tegn)'),
    writePositiveDetails: () =>
        __('Del gerne det positive ved arbejdspladsen – eller lad feltet stå tomt, hvis du ikke har en positiv oplevelse at tilføje'),
    writeNegative: () =>
        __('Negativt (maks. 600 tegn)'),
    writeNegativeDetails: () =>
        __('Del gerne det, du oplevede som mindre godt – eller lad feltet stå tomt, hvis du ikke har en negativ oplevelse at tilføje. Husk at skrive i en saglig og respektfuld tone'),

    statusHeader: () =>
        __('Hvordan kender du til virksomheden?'),
    commentHeader: () =>
        __('Vil du uddybe din evaluering anonymt?'),

    categoryName(category) {
        switch (String(category)) {
            case '2':
                return  __('Ledelse');
            case '5':
                return  __('Arbejdsmiljø og balance');
            case '4':
                return  __('Karrieremuligheder');
            case '7':
                return  __('Belønning');
            case '3':
                return  __('Kultur og mening');
            case '6':
                return  __('Samarbejde og relationer');
        }
    },
    categoryTooltip(category) {
        switch (String(category)) {
            case '2':
                return  __('Din vurdering af øverste og nærmeste ledelse samt ledelsens troværdighed.');
            case '5':
                return  __('Din vurdering af arbejdsmiljøet samt oplevet work-life balance.');
            case '4':
                return  __('Din vurdering af mulighederne for at avancere og dygtiggøre dig i din karriere.');
            case '7':
                return  __('Din vurdering af, om du bliver belønnet og anerkendt for dit arbejde.');
            case '3':
                return  __('Din vurdering af kultur og værdier, samt om du oplever mening i dit arbejde.');
            case '6':
                return  __('Din vurdering af samarbejdet med kolleger samt fællesskabsfølelsen.');
            case '1':
                return  __('Samlet vurdering af arbejdspladsen.');
        }
    },

    statusName(status) {
        switch (String(status)) {
            case '1':
                return  __('Nuværende ansat');
            case '0':
                return  __('Tidligere ansat');
            case '-1':
                return  __('Aldrig været ansat');
        }
    },

    termsText: () =>
        __('Når du benytter evalueringer, accepterer du samtidig, at du evaluerer nuværende og tidligere arbejdspladser inden for rammerne af vores betingelser.'),
    termsUrlText: () =>
        __('Læs mere om vilkår og betingelser'),

    completeHeader: () =>
        __('Tak for din evaluering!'),

    confirmDeleteHeader: () =>
        __('Bekræft sletning af evaluering'),
    confirmDeleteMessage: () =>
        __('Vælg igen slet evaluering for at bekræfte.'),

    nextButton: () =>
        __('Næste'),
    backButton: () =>
        __('Tilbage'),
    cancelButton: () =>
        __('Annuller'),
    closeButton: () =>
        __('Luk'),
    sendButton: () =>
        __('Evaluer arbejdsplads'),
    deleteButton: () =>
        __('Slet evaluering'),
};
